module.exports = __webpack_public_path__ + "static_pc/img/5.c8d3aa97.jpg";